import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import '../AdminShared.css';

export default function AboutTab() {
  const [bio, setBio] = useState('');
  const [photoUrl, setPhotoUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const load = async () => {
    setLoading(true);
    const { data, error } = await supabase.from('about').select('*').eq('id', 1).single();
    if (error) setError(error.message);
    else {
      setBio(data.bio || '');
      setPhotoUrl(data.photo_url || '');
    }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fileName = `about/${Date.now()}-${file.name}`;
    const { error } = await supabase.storage.from('images').upload(fileName, file);
    if (error) { setError(error.message); setUploading(false); return; }
    const { data } = supabase.storage.from('images').getPublicUrl(fileName);
    setPhotoUrl(data.publicUrl);
    setUploading(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    const { error } = await supabase
      .from('about')
      .update({ bio, photo_url: photoUrl })
      .eq('id', 1);

    setSaving(false);
    if (error) setError(error.message);
    else setSuccess('Saved!');
  };

  if (loading) return <p className="tab-status">Loading...</p>;

  return (
    <div>
      <div className="tab-header">
        <h2 className="tab-title">About Page</h2>
      </div>

      {error && <p className="tab-error">{error}</p>}
      {success && <p className="tab-success">{success}</p>}

      <form className="admin-form" onSubmit={handleSave}>
        <div className="admin-form-row">
          <label className="admin-form-label">Photo</label>
          <input type="file" accept="image/*" onChange={handleUpload} />
          {uploading && <span className="tab-status">Uploading...</span>}
          {photoUrl && (
            <img src={photoUrl} alt="about preview" className="admin-image-preview" />
          )}
        </div>

        <div className="admin-form-row">
          <label className="admin-form-label">Bio text</label>
          <textarea
            className="admin-form-textarea"
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            rows={8}
          />
        </div>

        <div className="admin-form-actions">
          <button className="admin-form-save" disabled={saving || uploading} type="submit">
            {saving ? 'Saving...' : 'Save changes'}
          </button>
        </div>
      </form>
    </div>
  );
}
